import React, { useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FaYoutube, FaPray, FaBroadcastTower } from "react-icons/fa";

// ✅ 유튜브 영상 ID
const YOUTUBE_VIDEO_ID = "R4woH45C8LI";

const LivePrayPage = () => {
  const [embedError, setEmbedError] = useState(false);

  // 영상 직접 embed URL
  const embedUrl = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0`;

  return (
    <div style={{ backgroundColor: "#f8f5f0", minHeight: "100vh", paddingBottom: "60px" }}>
      {/* 페이지 상단 헤더 */}
      <div
        style={{
          background: "linear-gradient(135deg, #6B4226 0%, #009590 100%)",
          padding: "50px 0 40px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* 배경 장식 */}
        <div
          style={{
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundImage:
              "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.05) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255,255,255,0.05) 0%, transparent 50%)",
          }}
        />

        <Container style={{ position: "relative", zIndex: 1 }}>
          <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
            <FaYoutube size={40} color="#FF0000" />
            <h1
              style={{
                color: "#fff",
                fontWeight: "700",
                fontSize: "2rem",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              실시간 소원기도
            </h1>
            <Badge
              style={{
                backgroundColor: "#FF0000",
                fontSize: "0.75rem",
                padding: "5px 10px",
                borderRadius: "20px",
                animation: "pulse 1.5s infinite",
              }}
            >
              <FaBroadcastTower size={10} className="me-1" />
              LIVE
            </Badge>
          </div>
          <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "1rem", margin: 0 }}>
            지금 이 순간, 함께 기도드립니다
          </p>
        </Container>
      </div>

      <Container className="mt-4">
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            {/* YouTube 영상 임베드 */}
            <Card
              style={{
                border: "none",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  paddingBottom: "56.25%", // 16:9 비율
                  height: 0,
                  backgroundColor: "#000",
                }}
              >
                <iframe
                  src={embedUrl}
                  title="비나이다 실시간 소원기도"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  onError={() => setEmbedError(true)}
                />
              </div>
            </Card>

            {/* 안내 문구 */}
            <Card
              className="mt-4"
              style={{
                border: "none",
                borderRadius: "16px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
              }}
            >
              <Card.Body className="p-4">
                <div className="d-flex align-items-start gap-3">
                  <FaPray size={28} color="#009590" style={{ flexShrink: 0, marginTop: "2px" }} />
                  <div>
                    <h5 style={{ fontWeight: "600", color: "#333", marginBottom: "8px" }}>
                      소원기도 안내
                    </h5>
                    <p style={{ color: "#666", lineHeight: "1.7", marginBottom: "8px" }}>
                      실시간 방송 중에 여러분의 소원을 채팅으로 남겨주시면 함께 기도해 드립니다.
                      방송이 없는 시간에는 이전 기도 영상이 재생될 수 있습니다.
                    </p>
                    <p style={{ color: "#666", lineHeight: "1.7", marginBottom: 0 }}>
                      유튜브에서 직접 보시려면{" "}
                      <a
                        href={`https://www.youtube.com/watch?v=${YOUTUBE_VIDEO_ID}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#009590", fontWeight: "600" }}
                      >
                        여기를 클릭
                      </a>{" "}
                      하세요.
                    </p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <style>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.6; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LivePrayPage;
